import React from 'react'

import styled from 'styled-components'

import { colors } from '../../constants/colors'
import { breakpoints } from '../breakPoints'
import { FlexColumn } from '../projectComponents'

interface BlockProps {
  $hideFilterButton?: boolean
  $noMarginRight?: boolean
}

const Block = styled(FlexColumn)<BlockProps>`
  cursor: pointer;
  width: 38px;
  height: 38px;
  margin-right: ${({ $noMarginRight }) => !$noMarginRight && '12px'};
  border-radius: 10px;
  background: ${colors.secondary};
  display: ${({ $hideFilterButton }) => $hideFilterButton && 'none'};

  img {
    height: 18px;
    width: 18px;
  }

  @media (width < ${breakpoints.tabletMin}) {
    margin-right: 0;

    img {
      width: 17.5px;
      height: 15.9px;
    }
  }
`

interface FilterProps {
  hideFilterButton?: boolean
  noMarginRight?: boolean
  onClickFilter: () => void
}

export const FilterButton: React.FC<FilterProps> = ({
  hideFilterButton,
  noMarginRight,
  onClickFilter,
}) => {
  return (
    <Block
      $hideFilterButton={hideFilterButton}
      $noMarginRight={noMarginRight}
      onClick={onClickFilter}
    >
      <img alt={''} src={'/images/buttons/filter-primary.svg'} />
    </Block>
  )
}
